import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchIcon, LoginIcon } from '@heroicons/react/solid';
import CompactNavbar from './../CompactNavbar/CompactNavbar';
import { Link, useNavigate } from "react-router-dom";
import Button from '../ui/Button';
import styles from './MorphingHeader.module.css';

const MorphingHeader = ({openContact, openLogin, showCompact = false}) => {
  const [isCompact, setCompact] = useState(showCompact);
	const [scrollY, setScrollY] = useState(0);
	const navigate = useNavigate();
	const { t } = useTranslation(); 
	
  useEffect(() => {
    const handleScroll = () => {
		setScrollY(window.scrollY);
	  //if (window.scrollY > 100) setCompact(true);
    };
	
	//console.log(window.scrollY, isCompact)
	if(window.scrollY > 100) setCompact(true);
	else if(isCompact == false && window.scrollY == 0) {
		window.scrollTo(0, 0);
		const element = document.getElementById("basic");
		element.scrollIntoView();
	}
    //const timer = setTimeout(() => setCompact(true), 5000);

    window.addEventListener('scroll', handleScroll);
    return () => {
      //clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`${styles.morphheader} ${isCompact ? styles.compact : ''}`}>
      <div className={styles.morphcontent} id="basic" >
        {!isCompact && (
			<div className={styles.heroo} >
			  <h2>{t('ui.motto')}</h2>
			  <p>{t('ui.joinCompetitive')}</p>
			  <div className={styles.herobuttons}>
				<Button variant="primary" className={styles.button} >
				  {t('ui.joinDebate')}
				</Button>
				<Button variant="secondary" className={styles.buttonoutline} >
				  {t('ui.createArena')}
				</Button>
			  </div>
			</div>
        )}

        {isCompact && (
          <>
		  <CompactNavbar  scrollY={scrollY} openContact={openContact} openLogin={openLogin}/>
		  </>
        )}
      </div>
    </header>
  );
};

export default MorphingHeader;
